import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button, Modal, Accordion } from 'react-bootstrap';

import FloatingLabelTextInput from '../../core/components/forms/FloatingLabelTextInput';
import selectIsModalOpened from '../../core/selectors/modal';
import { saveContactDetails } from '../actions';
import { setFormFieldValue } from '../actions/forms';
import { selectCartContactDetails, selectCartFormData } from '../selectors';
import { closeModal, openModal } from '../../core/actions/modal';
import { CONTACT_DETAILS_EMAIL_FIELD, CONTACT_DETAILS_FIRST_NAME_FIELD, CONTACT_DETAILS_FORM_NAME, CONTACT_DETAILS_LAST_NAME_FIELD,
    CONTACT_DETAILS_PHONE_FIELD } from '../reducers/features/contact-details';
import { CONTACT_DETAILS_MODAL } from '../../sell/constants/modal';

const ContactDetails = (open) => {
    const contactDetails = useSelector((state) => selectCartContactDetails(state));
    const inputs = useSelector((state) => selectCartFormData(state, CONTACT_DETAILS_FORM_NAME));
    const isOpen = useSelector((state) => selectIsModalOpened(state, CONTACT_DETAILS_MODAL));
    const dispatch = useDispatch();
    const onClose = () => dispatch(closeModal(CONTACT_DETAILS_MODAL));
    const openModalContactDetails = (e) => {
        e.stopPropagation();
        dispatch(openModal(CONTACT_DETAILS_MODAL));
    };

    return (
        <>
            <Accordion defaultActiveKey={open ? '0' : null}>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <span className="d-block mb-3 w-100">
                            <span className="h4">
                                <FormattedMessage id="cart_contact_details"/>
                            </span>
                            <a className="btn-change-seats ms-2 text-muted text-decoration-none"
                                onClick={openModalContactDetails}>
                                <i className="bi bi-pencil-square me-1" />
                                <FormattedMessage id="change"/>
                            </a>
                        </span>
                    </Accordion.Header>
                    <Accordion.Body>
                        <p><FormattedMessage id="cart_contact_details_info"/></p>
                        <div className="tickets-section">
                            <p className="mb-1">
                                <span className="text-muted"><FormattedMessage id="name"/>: </span>
                                {contactDetails.firstName} {contactDetails.lastName}
                            </p>
                            <p className="mb-1">
                                <span className="text-muted">Email: </span>
                                {contactDetails.email}
                            </p>
                            {contactDetails.phone && (
                                <p className="mb-0">
                                    <span className="text-muted"><FormattedMessage id="phone"/>: </span>
                                    {contactDetails.phone}
                                </p>)}
                        </div>
                        {!contactDetails.phone && (
                            <FloatingLabelTextInput controlId={CONTACT_DETAILS_PHONE_FIELD + 2} label={<FormattedMessage id="phone"/>}
                                isInvalid={!inputs[CONTACT_DETAILS_PHONE_FIELD].isValid}
                                value={inputs[CONTACT_DETAILS_PHONE_FIELD].value}
                                onChange={(e) => {
                                    dispatch(setFormFieldValue(CONTACT_DETAILS_FORM_NAME, CONTACT_DETAILS_PHONE_FIELD, e.target.value));
                                }}
                                errorMessage={inputs[CONTACT_DETAILS_PHONE_FIELD].errorMessage}
                            />
                        )}
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            <Modal show={isOpen} onHide={onClose} className="modal-fullscreen-sm-down">
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <h3 className="mb-0"><FormattedMessage id="cart_change_contact_details"/> </h3>
                    <p className="mb-4"><FormattedMessage id="cart_contact_details_title_modal"/></p>
                    <FloatingLabelTextInput controlId={CONTACT_DETAILS_FIRST_NAME_FIELD} label={<FormattedMessage id="first_name"/>}
                        isInvalid={!inputs[CONTACT_DETAILS_FIRST_NAME_FIELD].isValid}
                        value={inputs[CONTACT_DETAILS_FIRST_NAME_FIELD].value}
                        onChange={(e) => {
                            dispatch(setFormFieldValue(CONTACT_DETAILS_FORM_NAME, CONTACT_DETAILS_FIRST_NAME_FIELD, e.target.value));
                        } }
                        errorMessage={inputs[CONTACT_DETAILS_FIRST_NAME_FIELD].errorMessage}
                    />
                    <FloatingLabelTextInput controlId={CONTACT_DETAILS_LAST_NAME_FIELD} label={<FormattedMessage id="last_name"/>}
                        isInvalid={!inputs[CONTACT_DETAILS_LAST_NAME_FIELD].isValid}
                        value={inputs[CONTACT_DETAILS_LAST_NAME_FIELD].value}
                        onChange={(e) => {
                            dispatch(setFormFieldValue(CONTACT_DETAILS_FORM_NAME, CONTACT_DETAILS_LAST_NAME_FIELD, e.target.value));
                        }}
                        errorMessage={inputs[CONTACT_DETAILS_LAST_NAME_FIELD].errorMessage}
                    />
                    <FloatingLabelTextInput controlId={CONTACT_DETAILS_EMAIL_FIELD} label='Email'
                        isInvalid={!inputs[CONTACT_DETAILS_EMAIL_FIELD].isValid}
                        value={inputs[CONTACT_DETAILS_EMAIL_FIELD].value}
                        onChange={(e) => {
                            dispatch(setFormFieldValue(CONTACT_DETAILS_FORM_NAME, CONTACT_DETAILS_EMAIL_FIELD, e.target.value));
                        }}
                        errorMessage={inputs[CONTACT_DETAILS_EMAIL_FIELD].errorMessage}
                    />
                    <FloatingLabelTextInput controlId={CONTACT_DETAILS_PHONE_FIELD} label={<FormattedMessage id="phone"/>}
                        isInvalid={!inputs[CONTACT_DETAILS_PHONE_FIELD].isValid}
                        value={inputs[CONTACT_DETAILS_PHONE_FIELD].value}
                        onChange={(e) => {
                            dispatch(setFormFieldValue(CONTACT_DETAILS_FORM_NAME, CONTACT_DETAILS_PHONE_FIELD, e.target.value));
                        }}
                        errorMessage={inputs[CONTACT_DETAILS_PHONE_FIELD].errorMessage}
                    />
                    <Button variant="primary" onClick={() => dispatch(saveContactDetails(inputs))}>
                        <FormattedMessage id="save_changes"/>
                    </Button>
                </Modal.Body>
            </Modal>
        </>
    );
};
export default ContactDetails;
